var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoRightTool5Active(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "#70C2EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L21.4697 22.5303ZM14.8316 4.8227C17.5952 7.58629 17.5952 12.0681 14.8316 14.8316L15.8923 15.8923C19.2417 12.5429 19.2417 7.11142 15.8923 3.76204L14.8316 4.8227ZM14.8316 14.8316C13.8514 15.8119 12.2212 16.711 10.3979 16.9087C8.60596 17.103 6.61469 16.6236 4.8227 14.8316L3.76204 15.8923C5.89535 18.0256 8.34505 18.6401 10.5596 18.4C12.7429 18.1633 14.6849 17.0997 15.8923 15.8923L14.8316 14.8316ZM4.8227 14.8316C2.0591 12.0681 2.0591 7.58629 4.8227 4.8227L3.76204 3.76204C0.412655 7.11142 0.412655 12.5429 3.76204 15.8923L4.8227 14.8316ZM4.8227 4.8227C7.58629 2.0591 12.0681 2.0591 14.8316 4.8227L15.8923 3.76204C12.5429 0.412655 7.11142 0.412655 3.76204 3.76204L4.8227 4.8227ZM22.5303 21.4697L16.2298 15.1692L15.1692 16.2298L21.4697 22.5303L22.5303 21.4697Z",
    fill: "#414862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRightTool5Active);
export default __webpack_public_path__ + "static/media/ico-right-tool-5-active.25da0b1861924b0fbddf99abfe62b998.svg";
export { ForwardRef as ReactComponent };